import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie, X } from "lucide-react";

const COOKIE_KEY = "potop_cookie_consent";

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_KEY, "accepted");
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(COOKIE_KEY, "declined");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 120, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 120, opacity: 0 }}
          transition={{ type: "spring", damping: 25, stiffness: 300 }}
          style={{
            position: "fixed",
            bottom: 16,
            left: 16,
            right: 16,
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "100%",
              maxWidth: 560,
              background: "rgba(11,25,44,0.97)",
              border: "1px solid rgba(0,240,255,0.15)",
              borderRadius: 16,
              padding: "20px 24px",
              backdropFilter: "blur(20px)",
              WebkitBackdropFilter: "blur(20px)",
              boxShadow: "0 8px 40px rgba(0,0,0,0.5), 0 0 20px rgba(0,240,255,0.05)",
              position: "relative",
            }}
          >
            <button
              onClick={decline}
              style={{
                position: "absolute", top: 12, right: 12,
                background: "none", border: "none", cursor: "pointer",
                color: "rgba(255,255,255,0.4)", padding: 4,
              }}
              aria-label="Закрыть"
            >
              <X size={16} />
            </button>

            <div style={{ display: "flex", gap: 14, alignItems: "flex-start" }}>
              <div style={{
                width: 40, height: 40, borderRadius: 10,
                background: "rgba(0,240,255,0.08)",
                display: "flex", alignItems: "center", justifyContent: "center",
                flexShrink: 0,
              }}>
                <Cookie size={20} style={{ color: "#00F0FF" }} />
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{
                  color: "#fff", fontSize: 15, fontWeight: 600,
                  marginBottom: 6, fontFamily: "'Space Grotesk', sans-serif",
                }}>
                  Мы используем cookie
                </div>
                <div style={{
                  color: "rgba(255,255,255,0.55)", fontSize: 13,
                  lineHeight: 1.5, marginBottom: 14,
                }}>
                  Мы используем файлы cookie для обеспечения работы сайта и улучшения
                  вашего опыта. Подробнее —{" "}
                  <a
                    href="/privacy"
                    style={{ color: "#00F0FF", textDecoration: "none" }}
                  >
                    Политика конфиденциальности
                  </a>.
                </div>
                <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                  <button
                    onClick={accept}
                    style={{
                      padding: "8px 20px", borderRadius: 8,
                      border: "none", cursor: "pointer",
                      background: "linear-gradient(135deg, #00F0FF, #7A4DFF)",
                      color: "#fff", fontSize: 13, fontWeight: 600,
                      transition: "opacity 0.2s",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.85")}
                    onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
                  >
                    Принять все
                  </button>
                  <button
                    onClick={decline}
                    style={{
                      padding: "8px 20px", borderRadius: 8,
                      border: "1px solid rgba(0,240,255,0.2)",
                      background: "rgba(0,240,255,0.05)",
                      color: "rgba(255,255,255,0.7)", fontSize: 13, fontWeight: 500,
                      cursor: "pointer", transition: "all 0.2s",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.borderColor = "rgba(0,240,255,0.4)";
                      e.currentTarget.style.color = "#fff";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.borderColor = "rgba(0,240,255,0.2)";
                      e.currentTarget.style.color = "rgba(255,255,255,0.7)";
                    }}
                  >
                    Только необходимые
                  </button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
